export enum BookmarkFolderType {
  QuickMenu = 1,
  Dashboard
}
